module.exports = __webpack_public_path__ + "world.png?d54108ddfdd99bcc8014c9f5a8c35231";


//////////////////
// WEBPACK FOOTER
// ./src/assets/world.png
// module id = 272
// module chunks = 0